const { range } = require('lodash');

function getPageNumberSlice(pageNumbers, currentPage, totalPages, pagingElement) {
    const isPrevVisible = currentPage !== 1;
    const isNextVisible = currentPage !== totalPages;
    const numberOfPageNumbersToDisplay = Math.floor((pagingElement.width()
            - parseInt(parseFloat(pagingElement.css('marginLeft')) + parseFloat(pagingElement.css('marginRight')))
            - (isPrevVisible ? pagingElement.find('._pagingPrevious').width() : 0)
            - (isNextVisible ? pagingElement.find('._pagingNext').width() : 0))
        / (pagingElement.find('._pageNumber').width() || 45));

    // Make the slice a be window centered on the current page.
    // In the case that the numbe if pages to display is even, show higher numbers
    let startingIndex = currentPage - Math.floor(numberOfPageNumbersToDisplay / 2) - (numberOfPageNumbersToDisplay % 2 === 0 ? 0 : 1);

    // Clamp the starting index to the array bounds
    startingIndex = Math.max(0, Math.min(pageNumbers.length - numberOfPageNumbersToDisplay, startingIndex));

    return pageNumbers.slice(startingIndex, startingIndex + numberOfPageNumbersToDisplay);
}

class PagingController {
    constructor($state, $element, $timeout, pageMetadataService) {
        this.$state = $state;
        this.$element = $element;
        this.$timeout = $timeout;
        this.pageMetadataService = pageMetadataService;
    }

    $onInit() {
        this.updateMetadata = this.updateMetadata !== undefined ? this.updateMetadata : true;
        this.totalCount = this.totalCount === undefined ? 0 : this.totalCount;

        this.onUpdateCurrentPage();
    }

    $onChanges(changes) {
        if (changes.pageSize || changes.totalCount) {
            this.shouldDisplay = this.pageSize < this.totalCount;
            this.pageNumbers = range(1, Math.ceil(this.totalCount / this.pageSize) + 1);

            if (changes.currentPage) {
                this.onUpdateCurrentPage();
            }

            this.updateVisiblePageNumbers();
        }
    }

    onUpdateCurrentPage() {
        if (this.currentPage > this.pageNumbers.length) {
            this.$state.go('error.404', null, { location: 'replace' });
        }

        this.showPreviousButton = this.currentPage !== 1;
        this.showNextButton = this.currentPage !== this.pageNumbers.length;

        if (this.updateMetadata) {
            this.pageMetadataService.controlSeries(this.currentPage, this.pageNumbers.length);
        }

        this.pageMetadataService.setMetaRobotOnPageChange(this.currentPage, this.updateMetadata);
    }

    updateVisiblePageNumbers() {
        this.$timeout(() => {
            this.visiblePageNumbers = getPageNumberSlice(this.pageNumbers, this.currentPage, this.pageNumbers.length, this.$element.find('._pagingControl'));
        });
    }
}

PagingController.$inject = ['$state', '$element', '$timeout', 'PageMetadataService'];

const pagingComponentDefinition = {
    bindings: {
        currentPage: '<',
        pageSize: '<',
        totalCount: '<',
        onPageSelect: '&',
        updateMetadata: '<?',
    },
    controller: PagingController,
    template: require('./paging.component.html').trim(),
};

module.exports = {
    PagingController,
    pagingComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/paging/paging.component.js